<template>
  <v-row class="ma-0">
    <v-col class="pa-0">
      <div class="pa-0 pt-1" v-if="option.TextResponse !== ''">
        {{ isOptionAvailable() }}
      </div>
      <div v-else-if="option.PictureResponse !== ''">
        <span> {{ option.OptionName }}</span>
        <v-btn icon @click="downloadImage"
          ><v-icon dark color="primary"> mdi-download</v-icon></v-btn
        >
      </div>
      <div v-else>
        <span>{{ option.OptionName }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ActivityOptionsView',
  props: {
    item: Object,
    default: {},
  },
  watch: {
    item() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      option: this.item,
    };
  },
  methods: {
    init() {
      if (this.item !== null) this.option = this.item;
    },
    isOptionAvailable() {
      if (this.option != null && this.option.TextResposne !== '') {
        return this.option.OptionName + ' : ' + this.option.TextResponse;
      }
    },
    downloadImage() {
      if (this.option.PictureResponse === '') return;

      const url = this.option.PictureResponse;
      const fileName = url.substring(url.lastIndexOf('/') + 1);

      // on click, displays the image
      // const link = document.createElement('a');
      // link.href = url;
      // link.download = fileName;

      // link.click();
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';

      xhr.onload = () => {
        if (xhr.status === 200) {
          // create a blob object from the response data
          const blob = new Blob([xhr.response], { type: 'image/jpeg' });

          // create a temporary link element
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileName;

          // programmatically trigger the click event
          link.click();

          //clean up the temp URL object;
          URL.revokeObjectURL(link.href);
        }
      };
      xhr.send();
    },
  },
};
</script>
